import { FC } from 'react';
import Link from 'next/link';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import ProductCardRating from '../_reusable/productCardRating/ProductCardRating';
import Divider from '@/components/UI/divider/Divider';
import ProductCardMap from '../_reusable/productCardMap/ProductCardMap';
import styles from './ProductCardMidTerm.module.scss';
import { ProductListRecord } from '../types';
interface ProductCardMidTermProps {
  data: ProductListRecord;
  index?: number;
  cardHref: {
    pathname: string;
    query: {
      search_id?: string | undefined;
      cancel_link_type?: string | string[] | undefined;
      mid_term?: number | undefined;
    };
  };
  handleOpenHouse: () => void;
  redirectLink?: string;
}
const ProductCardMidTerm: FC<ProductCardMidTermProps> = ({
  data,
  index,
  cardHref,
  handleOpenHouse,
  redirectLink
}) => {
  return <Box className={styles['product-card-mid-term']} data-sentry-element="Box" data-sentry-component="ProductCardMidTerm" data-sentry-source-file="ProductCardMidTerm.tsx">
      <Link href={cardHref} data-house-id={data?.id} data-index={index} as={redirectLink} data-sentry-element="Link" data-sentry-source-file="ProductCardMidTerm.tsx">
        <Box component={'header'} className={styles['title_section']} data-sentry-element="Box" data-sentry-source-file="ProductCardMidTerm.tsx">
          <Typography variant="bodyL_Bold" className={styles['title']} component="h2" data-sentry-element="Typography" data-sentry-source-file="ProductCardMidTerm.tsx">
            {data?.title}
          </Typography>
        </Box>
      </Link>
      <Box className={styles['description']} data-sentry-element="Box" data-sentry-source-file="ProductCardMidTerm.tsx">
        <ProductCardRating rank={data?.rank} reviews={data?.reviews} data-sentry-element="ProductCardRating" data-sentry-source-file="ProductCardMidTerm.tsx" />
        <Divider orientation="vertical" data-sentry-element="Divider" data-sentry-source-file="ProductCardMidTerm.tsx" />
        <Typography variant="bodyM" color="secondary_main" onClick={handleOpenHouse} data-sentry-element="Typography" data-sentry-source-file="ProductCardMidTerm.tsx">
          {`${data?.rooms > 0 ? `${data?.rooms} اتاق، ${data?.building_area} متری ` : 'بدون اتاق'}`}
        </Typography>
        {data?.location.village && <>
            <Divider orientation="vertical" />
            <Box className={styles['location']}>
              <ProductCardMap location={data?.location} id={data?.id} isCarousel={false} title={data?.location.village || data?.location.city} />
            </Box>
          </>}
      </Box>
      <Divider className={styles['price-divider']} data-sentry-element="Divider" data-sentry-source-file="ProductCardMidTerm.tsx" />
    </Box>;
};
export default ProductCardMidTerm;